module.exports = __webpack_public_path__ + "img/bois_des_filion.375281bf.png";